export enum PcsEntity {
  DossierBasicData = 'DossierBasicData',
  Dossier = 'DossierModel',
  TrainId = 'TrainId',
  DossierLink = 'DossierLinkModel',
  DossierRuImPair = 'DossierRuImPairModel',
  DossierRuImPairParameter = 'DossierRUIMPairParameterModel',
  DossierRuImPairCoss = 'DossierRuImPairCossModel',
  DossierAgency = 'DossierAgencyModel',
  Territory = 'DossierTerritory',
  SubPath = 'TrasseModel',
  PathSection = 'TrasseElementModel',
  TrainComposition = 'TrainCompositionModel',
  CargoTrainComposition = 'CargoTrainCompositionModel',
  CargoTrainCompositionItem = 'CargoTrainCompositionItemModel',
  CargoCompositionItemStretch = 'CargoCompositionItemStretchModel',
  PassengerTrainComposition = 'PassengerTrainCompositionModel',
  PassengerTrainCompositionItem = 'PassengerTrainCompositionItemModel',
  TrainCompositionFootnote = 'TrainCompositionFootnoteModel',
  Connection = 'ConnectionModel',
  DangerousGoodsIndication = 'TrasseElementDangerousGoodsIndicationModel',
  LocoIdent = 'TrasseElementLocoIdentModel',
  ImParameter = 'TrasseElementParameterModel',
  CompositeRelation = 'CompositeRelationModel',
  CompositeRelationDossier = 'CompositeRelationDossierModel',
  LocoType = 'LocoType',
  LocoTypeNumber = 'LocoTypeNumber',
  Address = 'AddressModel',
  Label = 'LabelModel',
  PapRequest = 'PapRequestModel',
  User = 'PfUserModel',
  AgencyParameter = 'AgencyParameterModel',
  ActivityType = 'ActivityType',
  Comment = 'NoteElementModel',
  TimetablePeriod = 'UpdateTimetablePeriod',
  DeadlinePromotion = 'DeadlinePromotion',
  TimeLimitPromotion = 'TimeLimitPromotion',
  DailyPromotion = 'DailyPromotion',
  AgencyParameterTemplate = 'AgencyParameterTemplate',
  ParameterSetCodeTemplate = 'ParameterSetCodeTemplate',
  TrainParameters = 'TrainParameters',
  Appointment = 'AppointmentModel',
  CommonMandatoryParameters = 'CommonMandatoryParameters',
  CatalogData = 'CatalogData'
}
